import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { CornerLabelField } from "@/components/ui/corner-label-field";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useTranslation } from 'react-i18next';

type ProjectsTabProps = {
  preferences: any;
  preferencesLoading: boolean;
  updatePreferences: { mutate: (update: any) => void };
};

export default function ProjectsTab({
  preferences,
  preferencesLoading,
  updatePreferences,
}: ProjectsTabProps) {
  const { t } = useTranslation(['pages.settings']);

  return (
    <div>
      <div className="grid grid-cols-1 gap-6 max-w-2xl">
        <Card className="settings-card-muted">
          <CardHeader className="py-3 px-4">
            <CardTitle className="text-xs font-medium text-slate-700">{t('pages.settings:sections.notifications.ticketNotifications')}</CardTitle>
          </CardHeader>
          <CardContent className="p-3 space-y-3">
            <CornerLabelField label={t('pages.settings:sections.notifications.email')}>
              <Select
                value={preferences?.ticketEmailScope || 'all-projects'}
                onValueChange={(value) => updatePreferences.mutate({ ticketEmailScope: value })}
                disabled={preferencesLoading}
              >
                <SelectTrigger>
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="all-projects">{t('pages.settings:sections.notifications.allProjects')}</SelectItem>
                  <SelectItem value="assigned-only">{t('pages.settings:sections.notifications.assignedOnly')}</SelectItem>
                  <SelectItem value="none">{t('pages.settings:sections.notifications.noneEmail')}</SelectItem>
                </SelectContent>
              </Select>
            </CornerLabelField>

            <CornerLabelField label={t('pages.settings:sections.notifications.method')}>
              <Select
                value={preferences?.ticketNotificationMethod || 'daily'}
                onValueChange={(value) => updatePreferences.mutate({ ticketNotificationMethod: value })}
                disabled={preferencesLoading}
              >
                <SelectTrigger>
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="immediate">{t('pages.settings:sections.notifications.immediate')}</SelectItem>
                  <SelectItem value="daily">{t('pages.settings:sections.notifications.daily')}</SelectItem>
                  <SelectItem value="weekly">{t('pages.settings:sections.notifications.weekly')}</SelectItem>
                </SelectContent>
              </Select>
            </CornerLabelField>

            <CornerLabelField label={t('pages.settings:sections.notifications.when')}>
              <Select
                value={preferences?.ticketNotificationTime || '08:00'}
                onValueChange={(value) => updatePreferences.mutate({ ticketNotificationTime: value })}
                disabled={preferencesLoading}
              >
                <SelectTrigger>
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="06:00">06:00</SelectItem>
                  <SelectItem value="08:00">08:00</SelectItem>
                  <SelectItem value="10:00">10:00</SelectItem>
                  <SelectItem value="12:00">12:00</SelectItem>
                  <SelectItem value="14:00">14:00</SelectItem>
                  <SelectItem value="16:00">16:00</SelectItem>
                  <SelectItem value="18:00">18:00</SelectItem>
                </SelectContent>
              </Select>
            </CornerLabelField>

            <div className="grid grid-cols-2 gap-2">
              <CornerLabelField label={t('pages.settings:sections.notifications.deadlineReminder')}>
                <Select
                  value={preferences?.ticketDeadlineReminder || 'deadline'}
                  onValueChange={(value) => updatePreferences.mutate({ ticketDeadlineReminder: value })}
                  disabled={preferencesLoading}
                >
                  <SelectTrigger>
                    <SelectValue />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="deadline">{t('pages.settings:sections.notifications.deadlineAt')}</SelectItem>
                    <SelectItem value="day-before">{t('pages.settings:sections.notifications.dayBefore')}</SelectItem>
                    <SelectItem value="week-before">{t('pages.settings:sections.notifications.weekBefore')}</SelectItem>
                  </SelectContent>
                </Select>
              </CornerLabelField>
              <CornerLabelField label="">
                <Select
                  value={preferences?.ticketDeadlineReminderTime || '08:00'}
                  onValueChange={(value) => updatePreferences.mutate({ ticketDeadlineReminderTime: value })}
                  disabled={preferencesLoading}
                >
                  <SelectTrigger>
                    <SelectValue />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="06:00">06:00</SelectItem>
                    <SelectItem value="08:00">08:00</SelectItem>
                    <SelectItem value="10:00">10:00</SelectItem>
                    <SelectItem value="12:00">12:00</SelectItem>
                    <SelectItem value="14:00">14:00</SelectItem>
                    <SelectItem value="16:00">16:00</SelectItem>
                    <SelectItem value="18:00">18:00</SelectItem>
                  </SelectContent>
                </Select>
              </CornerLabelField>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
